export const schemaExample = {
  alias: "database_ca",
  countryCode: "CA",
  version: 1,
  collections: [
    {
      collection: "pyns",
      sqliteTable: "pyns",
      type: "geofirestore",
      filter: {
        attribute: "country",
        value: "CA"
      },
      attributes: [
        {
          name: {
            firebase: "active",
            sqlite: "active"
          },
          type: {
            firebase: "boolean",
            sqlite: "integer"
          }
        },
        {
          name: {
            firebase: "address",
            sqlite: "address"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "city",
            sqlite: "city"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "coordinates",
            sqlite: ["latitude", "longitude"]
          },
          type: {
            firebase: "geopoint",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "country",
            sqlite: "country"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "ePlaceId",
            sqlite: "ePlaceId"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "isImported",
            sqlite: "isImported"
          },
          type: {
            firebase: "boolean",
            sqlite: "integer"
          }
        },
        {
          name: {
            firebase: "name",
            sqlite: "name"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "psId",
            sqlite: "psId"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "pyn",
            sqlite: ["pyn_latitude", "pyn_longitude"]
          },
          type: {
            firebase: "geopoint",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "state",
            sqlite: "state"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "types",
            sqlite: "types"
          },
          type: {
            firebase: "array",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "uidCompany",
            sqlite: "uidCompany"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        }
      ]
    },
    {
      collection: "videos",
      sqliteTable: "videos",
      type: "db",
      attributes: [
        {
          name: {
            firebase: "numeration",
            sqlite: "numeration"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        },
        {
          name: {
            firebase: "url",
            sqlite: "url"
          },
          type: {
            firebase: "string",
            sqlite: "text"
          }
        }
      ]
    }
  ]
}
